import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { promise } from 'protractor';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ViajesService {

  constructor(public firestore:AngularFirestore,private http:HttpClient) { }

    lista1:Observable<any>; //Variable para almancenar el primer resultado del Filtro
    lista2:Observable<any> //Variable para almancenar el segundo resultado del Filtro

  /**
   * Recive una fecha de inicio y fin del servicio para despues buscar en los viajes
   * @param fechaInicio
   * @param fechaFin
   */
    obtenerUnidadesNoDisponibles(fechaInicio,fechaFin){
       //Primer busqueda almacenada en la primer lista
       return this.firestore.collection('viajes', ref => ref
       .where('finDeServicio', '>', fechaInicio)
       .where('finDeServicio', '<', fechaInicio + (1000 * 60 * 60 * 24*30))
       .where('finDeServicio', '<', fechaInicio + (1000 * 60 * 60 * 24*30))
       .where('disponibilidadFlexible', '==', "No")
       ).snapshotChanges().map(viajesDB=>{
            let lista=[]
            viajesDB.forEach((actions)=>{
            const data = actions.payload.doc.data();
            const $key = actions.payload.doc.id;

           if(data.inicioDeServicio<fechaFin )
                lista.push({$key:data['unidadAsignada']} )
          })
           return lista
        });
    }


    /**
   * Recive un arreglo de viajes
   * @param arregloDeViajes
   * @param origen
   */
    generarNueoViaje(arregloDeViajes, origen):Promise<any>{
        var size = Object.keys(arregloDeViajes); //Variable utilizada para  verificar el tamaño del arreglo de objetos
        if(size.length >= 100){//Verifica que el arreglo  mas de 100 vijes
            if(size.length > 500){ //Si contiene mas de 500 viajes realiza  la creacion por separado del viaje
                for (const key in arregloDeViajes) {
                    let firebaseKey = this.firestore.createId();
                    this.firestore.collection('viajes').doc(firebaseKey).set(arregloDeViajes[key])
                    this.firestore.collection('servicios').doc(arregloDeViajes[key].idServicio).update({'estatus': 'Asignado'})
                    if(origen=='masiva')
                        this.firestore.collection('confirmaciones').doc(arregloDeViajes[key].idConfirmacion).update({'asignacionMasivaDeViajes':true})
                }
                return Promise.resolve('Exito')
            }
            else{ //Si es menor de 500 se reaizan batch separados de viajes , actualizacion de servicios y  actualizacion de estatus de la confirmacion
                let batchViajes = this.firestore.firestore.batch();
                let batchServicios = this.firestore.firestore.batch();
                let batchConf = this.firestore.firestore.batch();
                for (const key in arregloDeViajes) {
                    let firebaseKey = this.firestore.createId();
                    batchServicios.set(this.firestore.firestore.collection('viajes').doc(firebaseKey),arregloDeViajes[key]);
                    batchViajes.update(this.firestore.firestore.collection('servicios').doc(arregloDeViajes[key].idServicio),{estatus: 'Asignado'});
                    if(origen=='masiva')
                        batchConf.update(this.firestore.firestore.collection('confirmaciones').doc(arregloDeViajes[key].idConfirmacion),{asignacionMasivaDeViajes:true})
                }
                let promise1 = batchViajes.commit();
                let promise2 = batchServicios.commit();
                let promise3 = batchConf.commit();
                return Promise.all([promise1, promise2, promise3]);


            }
        }else{
            //Debido a que es un arreglo se creo un batch para poder optimizar la creacion de los servicios
            let batch = this.firestore.firestore.batch();
            for (const key in arregloDeViajes) {
                let firebaseKey = this.firestore.createId();
                batch.set(this.firestore.firestore.collection('viajes').doc(firebaseKey),arregloDeViajes[key]);
                batch.update(this.firestore.firestore.collection('servicios').doc(arregloDeViajes[key].idServicio),{estatus: 'Asignado'});
                if(origen=='masiva')
                    batch.update(this.firestore.firestore.collection('confirmaciones').doc(arregloDeViajes[key].idConfirmacion),{asignacionMasivaDeViajes:true})
            }
            //return Promise.resolve('Exito')
            return batch.commit();
        }
    }
    /**
    * obtiene los viajes dentro de un rango de 40 horas
    * @param fechaInicial
    * @param fechaFinal
    */
    obtenerViajesDentroDe40Horas(fechaInicial,fechaFinal){
        return this.firestore.collection('viajes', ref => ref.where('inicioDeServicio', '>=', fechaInicial).where('inicioDeServicio', '<=', fechaFinal).orderBy('inicioDeServicio','asc'));
    }
    obtenerViajesOperadorElDiaDeHoy(inicioServicio,unidadAsignada){
       //console.log("Inicio",inicioServicio)
        //console.log("unidadAsignada",unidadAsignada)

        let fechaInicial = new Date(inicioServicio);
        let fechaFinal = new Date(inicioServicio);
        fechaInicial.setDate(fechaInicial.getDate()-1);
        fechaInicial.setHours(0);
        fechaInicial.setMinutes(0);
        fechaInicial.setSeconds(0);

        fechaFinal.setHours(23);
        fechaFinal.setMinutes(59);
        fechaFinal.setSeconds(59);

        return this.firestore.collection('viajes', ref => ref.
                                                                        where('inicioDeServicio', '>=', fechaInicial.getTime()).
                                                                        where('inicioDeServicio', '<=', fechaFinal.getTime()).
                                                                        where('unidadAsignada', '==', unidadAsignada));
       /* return this.firestore.collection('viajes', ref => ref.
                                                                            where('inicioDeServicio', '>=', fechaInicial.getTime()).
                                                                            where('inicioDeServicio', '<=', fechaFinal.getTime()).
                                                                            where('unidadAsignada', '==', unidadAsignada).
                                                                            orderBy('inicioDeServicio','asc')).snapshotChanges().map(viajesDB=>{
                                                                                let lista=[]
                                                                                viajesDB.forEach((actions)=>{
                                                                                    const data = actions.payload.doc.data();
                                                                                    const $key = actions.payload.doc.id;

                                                                                    lista.push({ $key, ...data})
                                                                                })
                                                                                console.log(lista)
                                                                                return lista
                                                                            });
*/
        /*return this.firestore.collection('viajes', ref => ref.where('unidadAsignada', '==', unidadAsignada).
                                                                            orderBy('inicioDeServicio','asc')).snapshotChanges().map(viajesDB=>{
                                                                                let lista=[]
                                                                                viajesDB.forEach((actions)=>{
                                                                                    const data = actions.payload.doc.data();
                                                                                    const $key = actions.payload.doc.id;

                                                                                    lista.push({ $key, ...data})
                                                                                })
                                                                                return lista
                                                                            });*/
    }
    /**
    * obtiene los viajes por un tipo de unidad
    * @param tipo
    */
    obtenerViajesPorTipoDeUnidad(tipo){
        return this.firestore.collection('viajes', ref => ref.where('tipoDeUnidad', '==', tipo))
    }
    /**
    * obtiene un viaje en especifo mediante su id
    * @param id
    */
    obtenerViajePorId(id){
        return this.firestore.collection('viajes').doc(id)
    }

    obtenerViajesPorIdConfirmacion(id){
        return this.firestore.collection('viajes', ref => ref.where('idConfirmacion', '==', id).where('inicioDeServicio','>',Date.now()))
    }
     /**
    *De el nodo de viaje actualiza unicamente la unidad  asignada,
    *NOTA: Con un cloud function actualzia la clave y el nombre del operador nuevos
    * @param tipo
    */
    actualizarUnidadEnViaje(idViaje,unidad){
        return this.firestore.collection('viajes').doc(idViaje).update({unidadAsignada:unidad})
    }
    eliminarViajes(listaViajes){
        let batch = this.firestore.firestore.batch();
        listaViajes.forEach(element => {
            batch.delete(this.firestore.firestore.collection('viajes').doc(element.$key));
        });
        return batch.commit();

    }

    crearEventoViaje(objetoEvento){
        return this.firestore.collection('viajes').add(objetoEvento)
    }

    obtenerViajesEntreFechas(fechaInicial, fechaFinal){
        return this.firestore.collection('viajes', ref => ref.orderBy('inicioDeServicio','asc').startAt(fechaInicial).endAt(fechaFinal));
    }
    obtenerViajesParaRevision(fechaInicial,fechaFinal){
        return this.firestore.collection('viajes',ref=>ref.orderBy('horaRevision').startAt(fechaInicial).endAt(fechaFinal).where('verMonitoreo','==',true))
    }

    /**
    *
    * @param ViajeKey
    * @param valor
    */

    notificarOperador(idOperador, idViaje, valor){
        this.firestore.collection('viajes').doc(idViaje).update({enviadaOperador: valor})
        return this.firestore.collection('notificaciones').add({userId:idOperador,fecha:Date.now(),viaje:idViaje})
    }
    cambiarEstatusViajeMonitoreo(idViaje, estatus){
        return this.firestore.collection('viajes').doc(idViaje).update({verMonitoreo: false, estatusRevisar:estatus})
    }
    agregarNota(id,nota, estat){
        return this.firestore.firestore.collection('viajes').doc(id).set({estatus:{[estat]:{'nota':nota}}},{merge:true})
    }

    obtenerIncidentesEntreFechas(fechaInicial, fechaFinal){
        return this.firestore.collection('incidentes',ref=>ref.orderBy('fecha').startAt(fechaInicial).endAt(fechaFinal).where('verificado', '==', false))
    }
    verificarIncidente(incidente){
        return this.firestore.collection('incidentes').doc(incidente).update({verificado:true})
    }

    obtenerViajesRechazados(){
        return this.firestore.collection('viajesRechazados',ref=>ref.where('revisado','==',false))
    }
    viajeRechazado(viaje){
        return this.firestore.firestore.collection('viajesRechazados').doc(viaje).set({revisado:true},{merge:true})
    }

    obtenerViajesConcluidosEntreFechas(fechaInicial, fechaFin){
        return this.firestore.collection('viajes',ref=>ref.where('estatusActual','==','concluido').orderBy('estatus.concluido.fecha').startAt(fechaInicial).endAt(fechaFin))
    }

    obtenerViajesPorServicio(idServicio){
        return this.firestore.collection('viajes',ref=>ref.where('idServicio','==', idServicio))
    }
    agregarPasajeroViaje(viaje, pasajero){
        let $key= this.firestore.createId()
        return this.firestore.firestore.collection('viajes').doc(viaje).set({pasajeros:{[$key]:pasajero}}, {merge:true})
    }
    agregarPasaServicio(servicio, pasajero){
        let $key= this.firestore.createId()
        return this.firestore.firestore.collection('servicios').doc(servicio).set({pasajeros:{[$key]:pasajero}}, {merge:true})
    }



    actulizarServicioConfirmacion(servicio){
        return this.firestore.collection('servicios').doc(servicio).update({})
    }
    actualizarViajePlaneacion(datos, viaje){
        return this.firestore.firestore.collection('viajes').doc(viaje).set(datos,{merge:true})
    }

    actualizarServicio(datos, servicio){
        return this.firestore.firestore.collection('servicios').doc(servicio).set(datos,{merge:true})
    }

    actualizarPuntosIntermedios(datos, servicio){
        return this.firestore.firestore.collection('servicios').doc(servicio).update('puntosIntermedios',datos.puntosIntermedios)
    }

    actualizarUnidadesServicio(datos, servicio,property){
        return this.firestore.firestore.collection('servicios').doc(servicio).update(property,datos)
    }


    public getHistoricoViajesEntreFechas(fechaInicial: string, fechaFinal: string): Observable<any> {
            const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

            const body = 'fecha_inicial='+fechaInicial+'&fecha_final='+fechaFinal;

            return this.http.post('https://operacion.trosten.com/corp-school/php/admin/HistoricoViajes/getHistoricoViajesEntreFechas.php', body,{headers});
        }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/viajes.service.ts